// ══════════════════════════════════════════════════════════
// CONSTANTES GLOBALES DEL JUEGO
// ══════════════════════════════════════════════════════════

export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 720;
export const ARENA_CENTER_X = GAME_WIDTH / 2;
export const ARENA_CENTER_Y = GAME_HEIGHT / 2;
export const ARENA_RADIUS = 280;

// Físicas
export const BASE_SPIN_SPEED = 1.5; // rad/s (punto medio)
export const BASE_ATTACK = 10;
export const BASE_HP = 100;
export const BASE_DENSITY = 0.01;
export const BASE_DEFENSE = 1.0;
export const BASE_STABILITY = 1.0;
export const FRICTION_AIR = 0.003; // aumentado para más frenado
export const FRICTION_GROUND = 0.8;
export const RESTITUTION = 0.4; // menos rebote
export const MAX_BEYBLADE_SPEED = 8; // velocidad lineal máxima (px/frame)
export const HP_MULTIPLIER = 1.5; // multiplicador global de HP
export const IA_DIRECTION_FORCE = 0.00015; // fuerza hacia rivales
export const START_INVULNERABILITY_TIME = 3000; // ms sin daño tras empezar

// Peonza - tamaños
export const BEYBLADE_CORE_RADIUS = 12;
export const BEYBLADE_RING_OUTER_RADIUS = 35;
export const BEYBLADE_RING_INNER_RADIUS = 22;
export const BEYBLADE_BASE_RADIUS = 8;

// Colisiones (categorías Matter.js)
export const CAT_BEYBLADE = 0x0001;
export const CAT_ARENA_WALL = 0x0002;
export const CAT_POWERUP = 0x0004;

// Power-ups
export const POWERUP_SPAWN_INTERVAL = 10000; // 10s
export const POWERUP_MAX_VISIBLE = 2;
export const POWERUP_COOLDOWN = 3000;
export const POWERUP_RADIUS = 15;

// Modo Clásico
export const CLASSIC_TIMEOUT = 300000; // 5 min

// Modo Dopamina
export const DOPAMINE_TIMEOUT = 300000; // 5 min
export const DOPAMINE_POINTS_HIT = 10;
export const DOPAMINE_POINTS_CRITICAL = 25;
export const DOPAMINE_POINTS_CENTER_CONTROL = 2; // por segundo
export const DOPAMINE_POINTS_POWERUP = 30;
export const DOPAMINE_POINTS_WALL_BOUNCE = 15;
export const DOPAMINE_POINTS_COMBO_BONUS = 50;
export const DOPAMINE_CENTER_ZONE_RADIUS = 80;

// Torneo
export const MIN_PARTICIPANTS = 4;
export const MAX_PARTICIPANTS = 16;
export const GROUP_SIZE = 4;

// IA
export const IA_DECISION_INTERVAL_EASY = 1000;
export const IA_DECISION_INTERVAL_MEDIUM = 600;
export const IA_DECISION_INTERVAL_HARD = 300;
export const IA_PRECISION_EASY = 0.6;
export const IA_PRECISION_MEDIUM = 0.75;
export const IA_PRECISION_HARD = 0.9;

// Jugadores
export const PLAYER_COLORS = [0x3498db, 0xe74c3c, 0x2ecc71, 0xf1c40f];
export const PLAYER_COLOR_NAMES = ['Azul', 'Rojo', 'Verde', 'Amarillo'];
